import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import CartItem from "../components/cart/CartItem";
import OrderSummary from "../components/cart/OrderSummary";

export default function Cart() {
  const { items } = useCart();

  return (
    <section className="mu-section">
      <div className="container">
        <h1 className="section-title mb-1">Your Cart</h1>
        <p className="section-sub mb-4">
          {items.length} item{items.length === 1 ? "" : "s"} in your cart
        </p>

        {items.length === 0 ? (
          <div className="text-center py-5">
            <p className="section-sub mx-auto mb-4">Your cart is empty. Let's fix that.</p>
            <Link to="/shop" className="btn-mu-solid">Browse the Shop &rarr;</Link>
          </div>
        ) : (
          <div className="row g-4">
            <div className="col-lg-8">
              {items.map((item) => (
                <CartItem item={item} key={item.id} />
              ))}
            </div>
            <div className="col-lg-4">
              <OrderSummary />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
